import { DataTableProps } from '@warrenbrasil/nebraska-web';
import { MultiRiskCell } from '@/modules/catalog/components/MultiRiskCell';
import { InstrumentNameCell } from '@/modules/trade/components/InstrumentNameCell';

const ipoLabel = (ipos: number) => {
  return ipos > 1 ? `${ipos} Produtos` : `${ipos} Produto`;
};

export const columns = (ipos: number): DataTableProps.Column[] => {
  return [
    {
      label: ipoLabel(ipos),
      component: InstrumentNameCell,
      sort: 'BaseAsset.Name',
      width: '25%',
      getter: ({ name, category }) => ({
        symbol: name,
        name: category,
        size: 'small',
        hasEllipsis: true
      })
    },
    {
      label: 'Mínimo inicial',
      align: DataTableProps.Align.Right,
      sort: 'MinimumInvestment',
      width: '15%',
      getter: 'minimumInvestment'
    },
    {
      label: 'Preço unitário',
      align: DataTableProps.Align.Right,
      sort: 'UnitPrice',
      width: '15%',
      getter: 'unitPrice'
    },
    {
      label: 'Reserve até',
      align: DataTableProps.Align.Right,
      sort: 'ReserveDate',
      width: '15%',
      getter: 'reserveDate'
    },
    {
      label: 'Liquidação',
      align: DataTableProps.Align.Right,
      sort: 'MaturityDate',
      width: '15%',
      getter: 'maturityDate'
    },
    {
      label: 'Risco',
      component: MultiRiskCell,
      align: DataTableProps.Align.Right,
      width: '15%',
      getter: ({ risk }) => ({
        risks: risk
      })
    }
  ];
};
